import styled from "styled-components";
import { useFetchEntities } from "@/reactQueryHooks";
import moment from "moment";
import NoteIcon from "@mui/icons-material/Note";
import { Avatar, Tooltip } from "@mui/material";

//------------------------------------------------------------------------

const NoteContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 8px;
  margin: 4px 0;
  border-left: 3px solid #f0c14b;
  background-color: #f2f3b8;
  border-radius: 0 4px 4px 0;
  font-size: 0.75rem;
`;

const UserInfoContainer = styled.div`
  display: flex;
  align-items: center;
  font-size: 10px;
  gap: 6px;
`;

const NoteContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const NoteHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #555;
`;

const NoteBody = styled.div`
  white-space: pre-wrap;
  color: #333;
  line-height: 1.4;
`;

const UserName = styled.span`
  font-weight: 600;
  color: #1568bb;
`;

const DateInfo = styled.span`
  font-size: 0.7rem;
  color: #777;
`;

const AvatarContainer = styled.div`
  display: flex;
  align-items: center;
`;

//------------------------------------------------------------------------

const ExternalAssignmentNote = ({
  user_id,
  body,
  date,
}: {
  user_id: string;
  body: string;
  date: string;
}) => {
  const { data: entities } = useFetchEntities() as any;
  const user = entities?.data?.staff?.find((u: any) => u._id === user_id);
  const formattedDate = moment(date).format("ddd, DD MMM YYYY - HH:mm");

  return (
    <NoteContainer>
      <AvatarContainer>
        <Avatar sx={{ width: 24, height: 24, bgcolor: "#f0c14b" }}>
          <NoteIcon sx={{ fontSize: 14 }} />
        </Avatar>
      </AvatarContainer>
      <NoteContent>
        <NoteHeader>
          <UserInfoContainer>
            <UserName>{user?.name || "Unknown User"}</UserName>
          </UserInfoContainer>
          <Tooltip title={formattedDate} arrow placement="top">
            <DateInfo>{moment(date).fromNow()}</DateInfo>
          </Tooltip>
        </NoteHeader>
        <NoteBody>{body}</NoteBody>
      </NoteContent>
    </NoteContainer>
  );
};

export default ExternalAssignmentNote;
